import React from 'react';

interface ProgressBarProps {
  value: number; // 0-100
  color?: string;
  height?: number;
  showLabel?: boolean;
  label?: string;
}

export function ProgressBar({ value, color = 'var(--color-primary)', height = 6, showLabel, label }: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, value));
  return (
    <div style={{ width: '100%' }}>
      {(showLabel || label) && (
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          marginBottom: '0.25rem', fontSize: 'var(--text-xs)',
          color: 'var(--color-text-muted)',
        }}>
          {label && <span>{label}</span>}
          {showLabel && <span>{Math.round(pct)}%</span>}
        </div>
      )}
      <div style={{
        background: 'rgba(255,255,255,0.06)',
        borderRadius: 'var(--radius-full)',
        height,
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          width: `${pct}%`,
          background: color,
          borderRadius: 'var(--radius-full)',
          transition: 'width 0.4s ease',
        }} />
      </div>
    </div>
  );
}
